import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Vi bruker informasjonskapsler',
    description:
      'Vi bruker informasjonskapsler og lignende teknologier for å tilby denne opplevelsen. Strengt nødvendige informasjonskapsler er alltid aktive.',
    allow_label: 'Godta alle informasjonskapsler',
    reject_label: 'Bare strengt nødvendige',
    settings_label: 'Innstillinger for informasjonskapsler',
    policy_link_label: 'Personvern- og retningslinjer for informasjonskapsler',
    categories_label: 'Kategorier',
    always_on_label: 'Alltid aktiv',
    required_label: 'Påkrevd',
    save_preferences_label: 'Lagre innstillinger',
    close_label: 'Lukk',
    allow_all_optional_categories_label: 'Tillat alle valgfrie kategorier',
    save_error: 'Vi kunne ikke lagre personvernvalget ditt. Prøv igjen.'
  },
  categories: {
    strictly_necessary: {
      name: 'Strengt nødvendige',
      purpose: 'Nødvendige for å tilby denne opplevelsen og kan ikke deaktiveres.'
    },
    analytics: {
      name: 'Analyse',
      purpose: 'Måler hvordan besøkende bruker denne opplevelsen for å forbedre ytelsen.'
    },
    marketing: { name: 'Markedsføring', purpose: 'Støtter annonsering og markedsføring valgt av arrangøren.' }
  }
};

export default locale;
